// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-title[data-v-0f4b6c99]{text-align:center;line-height:60px;font-weight:700;font-size:20px}", ""]);
// Exports
module.exports = exports;
